<template>
  <div class="div_help module">
    <Header :navIndex="3"/>

    <a-row type="flex" style="padding: 0 10px">
      <a-col flex="1">
        <div class="div_left txt_guide" @click="questionClick(0)">
          <div :class="{'color_green': this.questionModel === 0}">
            <a-icon type="question-circle" width="22"></a-icon>
            &nbsp;常见问题
          </div>
        </div>
      </a-col>
      <a-col flex="1">
        <div class="txt_guide div_left" @click="questionClick(1)" :class="{'color_green': this.questionModel === 1}">
          <a-icon type="snippets"  width="22"></a-icon>&nbsp;使用指南
        </div>
      </a-col>

      <a-col flex="1">
        <div class="txt_guide div_left" @click="questionClick(2)" :class="{'color_green': this.questionModel === 2}">
          <a-icon type="team"  width="22"></a-icon>&nbsp;商务合作
        </div>
      </a-col>
    </a-row>

    <a-row>
      <!--          常见问题-->
      <a-col :span="24" style="text-align: left" v-if="questionModel === 0">
        <a-row type="flex" justify="center">
          <!--          <a-input placeholder="" style="width: 200px" @search="onSearch">
                      <a-icon slot="prefix" type="search" />
                    </a-input>-->

          <!--          -->
          <a-select
            v-model="selectedItems"
            mode="multiple"
            size="default"
            placeholder="请选择"
            style="width: 200px"
            @change="handleQuestionChange"
            :maxTagCount="1"
            :maxTagPlaceholder="''"
          >
            <a-icon slot="suffixIcon" type="search" />
            <!--            index + ''-->
            <a-select-option v-for="(item, index) in questionItemList" :key="index + ''">
              {{item.question}}
            </a-select-option>
          </a-select>

          <br /><br />
        </a-row>
        <a-row type="flex" class="question_box"  v-if="questionIndex === -1" align="top" justify="center">
          <div style="width: 100%; flex: none; display: flex; flex-wrap: wrap;display: flex;justify-content: center">
            <a-col class="question_list_item" @click="questionIndex = 0">
              什么是喵呜账号？
            </a-col>
            <a-col class="question_list_item" @click="questionIndex = 0">
              注册码怎么获取？
            </a-col>
            <a-col class="question_list_item" @click="questionIndex = 1">
              什么是知识库？
            </a-col>
            <a-col class="question_list_item" @click="questionIndex = 6">
              如何成为代理？
            </a-col>
            <a-col class="question_list_item" @click="questionIndex = 0">
              是否支持多端同时在线？
            </a-col>
          </div>
        </a-row>

        <a-row class="question_box" v-if="questionIndex === 0">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 1">
          <div class="question_content"  style="width: 100%;float: left" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <div class="question_title">
              {{item.question}}
            </div>
            <div v-html="item.content">
            </div>
          </div>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 2">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 3">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 4">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 5">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 6">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 7">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
        <a-row class="question_box" v-if="questionIndex === 8">
          <a-row class="question_content"  style="width: 100%" v-for="(item, index) in questionList[questionIndex].list" :key="index">
            <a-row class="question_title">
              {{item.question}}
            </a-row>
            <a-row v-html="item.content">
            </a-row>
          </a-row>
        </a-row>
      </a-col>

      <!--          使用指南-->
      <a-col :span="24" style="text-align: left;padding: 0 10px" v-if="questionModel === 1">
        <a-row>
          <div class="help_img_div">
            <img v-lazy="img_help_title" class="help_img"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help0" width="862"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help1" class="help_img"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help2" class="help_img"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help3" class="help_img"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help4" class="help_img"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help5" class="help_img"/>
          </div>
          <div class="help_img_div img6_div">
            <img v-lazy="img_help6" width="612"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help7" class="help_img"/>
          </div>
          <div class="help_img_div">
            <img v-lazy="img_help8" class="help_img"/>
          </div>

          <Footer style="position: relative !important;;margin-top: 25px"/>
        </a-row>
      </a-col>

      <!--          商务合作-->
      <a-col :span="24" style="text-align: left" v-if="questionModel === 2">
        <div class="question_box" v-if="questionModel === 2" style="color: white">
          <div style="width: 100%; flex: none; display: flex; flex-wrap: wrap;">
            <a-row style="font-size: 20px;margin-bottom: 34px;">
              如果您对我们的AI名片产品感兴趣，可以先扫码进群交流哦
            </a-row>
            <a-row type="flex" justify="center" style="width:420px;font-size: 16px;margin-bottom: 16px;">
              <img v-lazy="weixin_nan" class="div_left" width="218px"/>
            </a-row>
            <a-row style="width:420px;font-size: 20px;user-select: text">
              <a-col flex="1">如果您想成为我们的代理商，可以联系：李凯</a-col>
              <a-col flex="1">电话：13770732882<br/>邮箱：363185744@qq.com</a-col>
            </a-row>
          </div>
        </div>
      </a-col>
    </a-row>
    <!--底部版权声明-->
    <Footer v-if="questionModel !== 1" style="position: relative !important;"/>
  </div>
</template>

<script>
import Header from './HeaderMobile.vue'
import Footer from './../Footer.vue'
import {constQuestionList} from '../../utils/constant'

export default {
  name: 'Help',
  components: {Header, Footer},
  props: [],
  data () {
    return {
      questionModel: 0,
      questionIndex: -1, // 常见问题列表的激活key
      weixin_nan: require('@/assets/weixin_nan.png'),
      img_help_title: require('@/assets/help/img_help_title.png'),
      img_help0: require('@/assets/help/img_guide_1.png'),
      img_help1: require('@/assets/help/img_guide_2.png'),
      img_help2: require('@/assets/help/img_guide_3.png'),
      img_help3: require('@/assets/help/img_guide_4.png'),
      img_help4: require('@/assets/help/img_guide_5.png'),
      img_help5: require('@/assets/help/img_guide_6.png'),
      img_help6: require('@/assets/help/img_guide_8.png'),
      img_help7: require('@/assets/help/img_guide_9.png'),
      img_help8: require('@/assets/help/img_guide_10.png'),
      selectedItems: [],
      searchText: '',
      questionList: constQuestionList
    }
  },
  inject: ['showLogin'],
  computed: {
    questionItemList () {
      let filterList = []
      for (let i = 0; i < this.questionList.length; i++) {
        let questionCollect = this.questionList[i].list
        for (let j = 0; j < questionCollect.length; j++) {
          let filterItem = {}
          filterItem.question = questionCollect[j].question
          filterItem.index = i
          filterList.push(filterItem)
        }
      }
      return filterList
    }
  },
  created () {
    if (!this.$store.state.isMobile) {
      this.$router.push('/help')
    }
  },
  mounted () {
    const contact = this.$route.query.contact
    if (contact && contact !== '') {
      if (contact === '0' || contact === '1' || contact === '2') {
        this.questionClick(parseInt(contact))
      } else {
        this.questionModel = 2
      }
    }
  },
  methods: {
    onSearch () {
      console.log('onSearch')
    },
    questionClick (index) {
      console.log('questionClick', index)
      if (index === 0) {
        this.questionIndex = -1 // 设置为常见问题里的主标题高亮
        this.questionModel = index
      } else if (index === 1) {
        // 使用指南得判断是否已经登录了 否则不允许查看
        if (this.$store.state.userAuth.haveLogin) {
          this.questionModel = index
        } else {
          if (this.$store.state.isMeuHost) {
            this.$message.error('暂不支持')
          } else {
            this.showLogin()
          }
        }
      } else {
        this.questionModel = index
      }
    },
    clickQuestion (index) {
      this.questionModel = 0
      this.questionIndex = index
    },
    handleQuestionChange (target) {
      console.log('tar', target)
      console.log('tar selectedItems', this.selectedItems)
      if (target.length > 0) {
        this.selectedItems = target.slice(-1)
        this.questionIndex = this.questionItemList[target[0]].index
      } else {
        this.questionIndex = -1
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .div_help{
  }
  .txt_question{
    width: 100%;
    height: 30px;
    font-size: 20px;
    font-weight: 400;
    color: white;
    line-height: 23px;
  }
  .color_green{
    color: #28E04A !important;
  }
  .question_ul{
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: left;
    li{
      list-style: none;
      height: 25px;
      font-size: 18px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 21px;
      margin: 10px 0;
    }
  }
  .txt_guide{
    font-size: 20px;
    font-weight: 400;
    line-height: 23px;
    margin-bottom: 22px;
    color: white;
  }
  .question_list_item{
    width: 296px;
    height: 60px;
    background: rgba(40,224,74,0.2);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgba(40,224,74,0.5);
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 60px;
    margin: 0 22px 22px 0;
  }
  .help_img_div{
    display: flex;
    justify-content: center;
  }
  .help_img{
    margin: 78px 0;
    width: 1000px;
  }
  .question_title{
    font-size: 22px;
    font-weight: 500;
    line-height: 1.5;
    color: white;
    width: 100%;
    float: left;
    margin-bottom: 5px;
  }
  .question_content{
    font-weight: 400;
    font-size: 17px;
    line-height: 1.5;
    color: whitesmoke;
    margin-bottom: 20px;
    width: 100%;
  }
  .question_box{
    min-height: calc(100vh - 250px);
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/HelpMobile.vue